import { render } from "./relojes.vue?vue&type=template&id=0685bfdc"
import script from "./relojes.vue?vue&type=script&lang=js"
export * from "./relojes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__